export default "__VITE_ASSET__400836db__"